import { AuthContext } from '@core/shared';
import { ContainerDefault, Heading, SearchInput, Switch } from '@core/ui';
import { Link } from '@online-webinar/router';
import { useContext, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { WebinarsListNav, WebinarsListOnDemand } from '../../organisms';

export const OnDemandWebinarsPage = () => {
    const { t } = useTranslation();
    const { isAuthenticated } = useContext(AuthContext);
    const [interestedOnly, setInterestedOnly] = useState(false);
    const [search, setSearch] = useState<string>('');

    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }

        if (globalThis.sessionStorage && globalThis.sessionStorage.getItem('interestedOnly') === 'true') {
            setInterestedOnly(true);
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if (globalThis.sessionStorage) {
            globalThis.sessionStorage.setItem('interestedOnly', interestedOnly.toString());
        }
    }, [interestedOnly]);

    return (
        <ContainerDefault>
            <div data-testid="webinarsList" className="max-w-300">
                <Heading variant="h1" classNames="mb-8 md:mb-10">
                    {t('Schedule.PageHeading')}
                </Heading>
                <WebinarsListNav page="on-demand" />
                <SearchInput classNames="mt-4" onSearch={(value) => setSearch(value)} />
                {isAuthenticated && (
                    <Switch
                        classNames="w-fit mt-4 mx-auto"
                        label={t('Schedule.Switch.ShowInterested')}
                        checked={interestedOnly}
                        onChange={() => setInterestedOnly(!interestedOnly)}
                    />
                )}
                {!isAuthenticated && (
                    <p className="bg-info rounded-webinarsub text-center mt-2 p-4">
                        <Trans i18nKey="Schedule.LoginToSeeWebinars" components={{ a: <Link to="/login" from="/on-demand" className="link" /> }} />
                    </p>
                )}
                <WebinarsListOnDemand interestedOnly={interestedOnly} search={search} />
            </div>
        </ContainerDefault>
    );
};
